import { combineTokens } from '@utils/css';

const tokens = combineTokens("--iark-tools", {
  buttonCount: 4
});
const tools = "_086t1r6okxi";
const separator = "_086svanw3r";
const speechSynthesisWrapper = "_086st68e6i";
const speechSynthesisButton = "_086s16qea7n";

export { separator, speechSynthesisButton, speechSynthesisWrapper, tokens, tools };
import "./_tools.style.linaria.module.css";
//# sourceMappingURL=_tools.style.js.map
